@import 'styles/mixins';
@import 'styles/variables';

.content {
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.logo {
  max-width: 30px;
  max-height: 30px;
}
